import actions from './inspectionsActions'
import mutations from './inspectionsMutations'

export default {
  namespaced: true,
  actions,
  mutations
}